var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInboxIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.375 310.625C245.875 323.125 266.125 323.125 278.625 310.625L374.625 214.625C387.125 202.125 387.125 181.875 374.625 169.375S341.875 156.875 329.375 169.375L288 210.75V32C288 14.312 273.688 0 256 0S224 14.312 224 32V210.75L182.625 169.375C176.375 163.125 168.188 160 160 160S143.625 163.125 137.375 169.375C124.875 181.875 124.875 202.125 137.375 214.625L233.375 310.625ZM480 320H384L352 384H160L128 320H32C14.326 320 0 334.328 0 352V464C0 490.508 21.49 512 48 512H464C490.51 512 512 490.508 512 464V352C512 334.328 497.674 320 480 320Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxIn);
export default __webpack_public_path__ + "static/media/inbox-in.a38bf1377e3ba5f919cf7ccf105ae753.svg";
export { ForwardRef as ReactComponent };